<template>
  <ul class="list">
    <li v-for="(item,index) in list" :key="index">
      <router-link :to="'/dynamic/detail/'+item.id+'?type='+type" class="fs16">
        <span class="time pc">{{item.created_at}}</span>
        <div class="title ell">
          <span class="mobile">{{item.created_at}}</span>
          <span class="ell">{{item.title}}</span>
        </div>
        <i class="el-icon-d-arrow-right"></i>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Title',
  props:{
    type:{type:String,default:'news'},
    list:{type:Array,default:[]}
  }
}
</script>

<style scoped>
.list li>a{display:flex; justify-content: space-between; height:3.68vw; line-height:3.68vw; border-bottom:1px solid #e7e7e7; color:#212121; transition-duration: 300ms; box-sizing: border-box; padding:0 2px;}
.list li:nth-of-type(1)>a{border-top:1px solid #e7e7e7;}
.list li .time{flex:0 0 13vw; width:13vw;}
.list li .title{flex:1 1 auto; min-width: 0;}
.list li i{flex:0 0 30px; width:30px; line-height:3.68vw; text-align:right;}
.list li>a:hover{color:#f50045; background: #f8f8f8;}

@media (max-width: 991px){
.list li>a{height:15vw; line-height:15vw; border-bottom:0.5px solid #e7e7e7;}
.list li:nth-of-type(1)>a{border-top:0.5px solid #e7e7e7;}
.list li .time{flex:0 0 19vw; width:19vw;}
.list li .title{display:flex; flex-direction: column; justify-content: center; line-height:4vw;}
.list li .title>span:nth-of-type(1){color:#999; margin-bottom:1vw;}
.list li .title>span:nth-of-type(2){font-size:3.5vw;}

.list li i{line-height:15vw; }
}
</style>